export default function docDimSettings(settings) {
  const displayUnit = settings.display_unit;
  const dimFormat =
    displayUnit === "inches" ? settings.dimension_format : "DECIMAL";
  const sddp = settings.dim_decimal_precision;
  const sdfp = settings.dim_fractional_precision;
  const dimPrecision =
    displayUnit === "inches"
      ? dimFormat === "DECIMAL"
        ? sddp
        : sdfp
      : settings.dim_mm_precision;

  return { displayUnit, dimFormat, dimPrecision };
}
